var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6053 4.5C10.1904 4.5 9.85645 4.83398 9.85645 5.24883V12.7477C9.85645 14.8184 8.17949 16.4988 6.10527 16.4988C4.03105 16.4988 2.3541 14.8184 2.3541 12.7477V3.74766C2.3541 2.50664 3.35957 1.49766 4.6041 1.49766C5.84863 1.49766 6.8541 2.50664 6.8541 3.74766V11.25C6.8541 11.6648 6.5166 11.9988 6.10527 11.9988C5.69395 11.9988 5.35645 11.6648 5.35645 11.25V5.24883C5.35645 4.83398 5.01895 4.5 4.60762 4.5C4.19277 4.5 3.85879 4.83398 3.85879 5.24883V11.25C3.85879 12.4945 4.86426 13.5 6.10879 13.5C7.35332 13.5 8.35879 12.4945 8.35879 11.25V3.75117C8.35527 1.68047 6.6748 0 4.6041 0C2.5334 0 0.856445 1.68047 0.856445 3.75117V12.7512C0.856445 15.6516 3.2084 18 6.10527 18C9.00215 18 11.3541 15.648 11.3541 12.7512V5.24883C11.3541 4.83398 11.0201 4.5 10.6053 4.5Z",
    fill: "#1B75BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipSvg);
export default __webpack_public_path__ + "static/media/clipSvg.36bf548d6521b1d372418a467d6b362e.svg";
export { ForwardRef as ReactComponent };